<template>
  <div>
    <div class="avatar"></div>
    <p>闲物新生 品质至上</p>
    <div class="download" @click="downloadApp">
      <span v-show="!isShow">下载</span>
      <van-loading size="24px" text-color="#fff" v-show="isShow"
        >加载中...</van-loading
      >
    </div>
    <!-- <van-loading size="24px" v-show="isShow">加载中...</van-loading> -->
  </div>
</template>


<script>
export default {
  name: "sharePage",
  data() {
    return {
      isIos: false,
      isAndroid: false,
      schemeUrl: "",
      downloadUrl: "http://qr15.cn/F6fhRD",
      isShow: false,
    };
  },
  created() {},
  mounted() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      this.isAndroid = true;
      this.schemeUrl = "xzyp://com.xzyp.app";
      this.downloadUrl = "http://qr15.cn/F6fhRD";
    }
    if (isIOS) {
      this.isIos = true;
      this.schemeUrl = "tencent101482537://";
      this.downloadUrl = "http://qr15.cn/F6fhRD";
    }
  },
  methods: {
    downloadApp() {
      if (!this.isBlackApp()) {
        this.isShow = true;
        this.openTuer();
      } else {
        //显示手动打开外置浏览器提示
        this.isShow = false;
        this.$toast("请在右上角选择默认浏览器打开");
      }
    },
    isBlackApp() {
      var u = navigator.userAgent.toLowerCase();
      return (
        /micromessenger/i.test(u) ||
        u.indexOf("weibo") > -1 ||
        u.indexOf("qq") > -1 ||
        u.indexOf("mqqbrowser") > -1
      );
    },
    // 点击打开app
    openTuer() {
      this.jumpApp(this.schemeUrl);
      this.noApp();
      setTimeout(() => {
        this.isShow = false;
      }, 1000);
    },
    // 跳转打开app
    jumpApp(t) {
      console.log(t);
      try {
        var e = navigator.userAgent.toLowerCase(),
          n = e.match(/cpu iphone os (.*?) like mac os/);
        if (
          ((n = null !== n ? n[1].replace(/_/g, ".") : 0), parseInt(n) >= 9)
        ) {
          window.location.href = t;
        } else {
          var r = document.createElement("iframe");
          (r.src = t), (r.style.display = "none"), document.body.appendChild(r);
        }
      } catch (e) {
        window.location.href = t;
      }
    },
    // 无响应或者没安装跳转下载
    noApp() {
      var t = Date.now(),
        r = this.downloadUrl;
      console.log(r);
      this.timer = setTimeout(function () {
        return Date.now() - t > 2200
          ? (clearTimeout(this.timer), !1)
          : !document.webkitHidden &&
              !document.hidden &&
              void (location.href = r);
      }, 2000);
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 120px;
  height: 120px;
  background: url("../assets/logo2.jpg");
  background-size: 100% 100%;
  margin: 6.25rem auto;
  margin-bottom: 0;
}
p {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1rem;
  color: #999;
  margin-top: 2.5rem;
  margin-bottom: 1.875rem;
}
.download {
  width: 11rem;
  height: 2rem;
  background: linear-gradient(317deg, #ff1b01, #ff9742);
  border-radius: 0.9375rem;
  text-align: center;
  line-height: 2rem;
  margin: 0.94rem auto;
  font-size: 0.875rem;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/download.vue